<template>
  <div class="mb-3" :class="FormDataType.FieldSize">
   
    <b-form-group
      :class="title_position"
      :label-cols-lg="labels_lg"
      id="example text"
      :label="FormDataType.FieldTitle"
      label-for="text"
    > 

      <treeselect
        name="name"
        :multiple="false"
        :disabled="FormDataType.Disabled"
        :options="FormDataType.ComboDataArray"
        :placeholder="$t('OrtakKullanim.seciniz')"
        v-model="InputName"
        :class="{ 'is-invalid': v.$error }"
        @select="$emit('input', $event.id)"
      />
      <treeselect-value :value="InputName" />

      <div v-if="v.$error" class="invalid-feedback">
        <span v-if="v.required == false">{{
          $t("ValidationMessage.required")
        }}</span>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  data() {
    return {
      InputName: "",
    };
  },
  components: {
    Treeselect,
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: null,
    min: String,
    max: String,
    name:String,
    title_position: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
    InputName(){
      if(this.InputName=="" || this.InputName==null ){
        this.$emit("unselect",1);
      }else{
        this.$emit("unselect",0);
      }
    }
  },
  created: function () {
    this.InputName = this.Value;
  }, 
};
</script>
